<script>
import ToutiaoProject from '../toutiaonew/ToutiaoProject.vue'

export default {
  name: 'ToutiaoV3Project',
  components: { ToutiaoProject }
}
</script>

<template>
  <ToutiaoProject :sub-media-id="3" />
</template>
